import { Button, Modal, Text } from "@pushpress/shared-components";
import React from "react";
import styles from "./ConfirmModal.module.scss";

interface ConfirmDialogProps {
  visible: boolean;
  title: string;
  message?: string;
  loading?: boolean;
  okayLabel: string;
  okayType?: "primary" | "destructive";
  onCancel: () => void;
  onOkay: () => void;
}

const ConfirmDialog = (props: ConfirmDialogProps) => {
  const {
    title,
    message,
    visible,
    loading,
    okayLabel,
    okayType = "primary",
    onCancel,
    onOkay,
  } = props;

  return (
    <Modal visible={visible} closeModal={onCancel}>
      <div className={styles.root}>
        <Text variant="heading-4" color="wolf-800">
          {title}
        </Text>
        {message && (
          <Text variant="body-lg" color="wolf-600" className="mt-2">
            {message}
          </Text>
        )}
        <div className={styles.actions}>
          <Button
            buttonType="secondary"
            type="button"
            onClick={onCancel}
            text="Go Back"
          />
          <Button
            buttonType={okayType}
            type="button"
            loading={loading}
            text={okayLabel}
            color="red"
            onClick={onOkay}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDialog;
